import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SubMenu from "../../../Menu/SubMenu";
import EmperorTentBanner, { InfoValue } from "../../../Common/EmperorTentBanner";
import { GovernyInfo, Upgrade } from "../../../../lib/types";
import { getData } from "../../../../lib/commonFunctions";
import { DragescentState } from "../../../../store/reducers/stateType";
import ArmyUnitPerson from "./ArmyUnitPerson";
import { ARMY_UNITS, systemClass, UPGRADES } from "../../../../lib/enums";
import { initEmperorTentState, recruitUnit, releaseUnit } from "../../../../store/actions";
import { armyUnits } from "../../../../assets/images/army";
import { setSameHeight } from "../../../../lib/elementUtilities";
import ArmyFormationPersons from "./ArmyFormationPersons";
import InnerLoader from "../../../Common/InnerLoader";
import DialogButton from "../../../Common/DialogButton";
import { icons } from "../../../../assets/images/icons";

const ArmyEmperorTentSubmenu = () => <SubMenu
    tabs={[
      {
        name: "Army",
        title: "Army",
        icon: "armada",
        label: "Army",
        active: false,
        parameters: {
          reload: true
        }
      },
      {
        name: "ArmyEmperorTent",
        title: "Army",
        icon: "armada",
        label: "Emperor Tent",
        active: true,
        parameters: {
          reload: false
        }
      }
    ]}
  />

const ArmyEmperorTent = () => {
  const govRef = useRef(null);
  const armyPersonsRef = useRef(null);

  const [selectedMember, setSelectedMember] = useState<GovernyInfo | null>(null);
  const id = useSelector((state: DragescentState) => state.governorate.id);
  const race = useSelector((state: DragescentState) => state.governorate.race);
  const alliance = useSelector((state: DragescentState) => state.governorate.alliance);
  const armyFormation = useSelector((state: DragescentState) => state.governorate.armyFormation);
  const data = useSelector((state: DragescentState) => state.emperorTent);
  const armyEmperorTentUpgrade = useSelector((state: DragescentState) => state
    .governorate.upgrades.find((u: Upgrade) => u.id === UPGRADES.ArmyEmperorTent));
  const armyEmperorTent = useSelector(
    (state: DragescentState) => state.governorate.armyEmperorTent
  );
  const credits = useSelector((state: DragescentState) => state.governorate.player.credits);

  const dispatch = useDispatch();

  useEffect(() => {
    if (alliance) {
      getData(`/api/emperorTent/data/army`)
        .then((emperorTentData) => {
          dispatch(initEmperorTentState(emperorTentData));
          if (!selectedMember) {
            setSelectedMember(emperorTentData.members[0]);
          }
          setSameHeight(govRef.current || undefined);
          setSameHeight(armyPersonsRef.current || undefined);
        });
    }

    return () => {
      dispatch(initEmperorTentState())
    };
  }, []);

  useEffect(() => {
    if (data.members && selectedMember) {
      setSelectedMember(data.members
        .find((member: GovernyInfo) => member.id === selectedMember.id) || null);
    }

    setSameHeight(govRef.current || undefined);
    setSameHeight(armyPersonsRef.current || undefined);
  }, [data]);

  if (!armyEmperorTent) {
    return <>
      <ArmyEmperorTentSubmenu />
      <div className="box">
        <div className="row">
          <div className="col-md-12 text-center">
            <div className="text-bigger">
              Army emperor tent allows you to recruit/release&nbsp;
              army units and set banner for all members of your alliance.
            </div>
            <p>Army emperor tent not purchased</p>
            <DialogButton
              dialogOptions={{
                name: "PurchaseUpgrade",
                header: "Army emperor tent",
                id: UPGRADES.ArmyEmperorTent,
                params: {},
                question: "Purchase Army emperor tent?",
                purchasable: !(credits < armyEmperorTentUpgrade.price),
                price: armyEmperorTentUpgrade.price
              }}
            >
              GET <img src={icons.credit} alt=""/>
            </DialogButton>
          </div>
        </div>
      </div>
      <span className="divider"/>
    </>
  }

  if (!alliance) {
    return <>
      <ArmyEmperorTentSubmenu />
      <div className="box">
        <div className="row">
          <div className="col-md-12 text-center">
            <div className="text-bigger">
              Army emperor tent can be used only in alliances.
            </div>
          </div>
        </div>
      </div>
      <span className="divider"/>
    </>
  }


  return (<section className="boxes-group">
    <ArmyEmperorTentSubmenu />
        {data && data.members && selectedMember ? <>
          <div className="box text-center padding">
            <div className="row persons generals" ref={govRef}>
          {data.members.map(member => <EmperorTentBanner
            id={member.id}
            name={member.name}
            race={member.race}
            info={{
              [InfoValue.TURNS]: `${member.turn}/${member.maxTurns}`,
              [InfoValue.ATTACK]: (member.generals?.soldier?.general?.attack.sum || 0).toString(),
              [InfoValue.DEFENCE]: (member.generals?.soldier?.general?.defence.sum || 0).toString(),
              [InfoValue.POPS]: `${member.population} (${member.populationFree})`,
              [InfoValue.GOLD]: `${member.resources.gold}`,
              [InfoValue.WEAPONS]: `${member.resources.weapons}`
            }}
            setUpAction={() => setSelectedMember(member)}
            active={selectedMember?.id === member.id}
          />)}
              {data.members.length < 4 && new Array(4 - data.members.length).fill("").map(() => <EmperorTentBanner
                info={{
                  [InfoValue.TURNS]: "-",
                  [InfoValue.ATTACK]: "-",
                  [InfoValue.DEFENCE]: "-",
                  [InfoValue.POPS]: "-",
                  [InfoValue.GOLD]: "-",
                  [InfoValue.WEAPONS]: "-"
                }}
                active={false}
              />)}
            </div>
          </div>

          <section className={selectedMember.race.name}>
          <h2 className="h2 h2-first">
            <span className="bordered">Units of {selectedMember.name}</span>
          </h2>
          <span className="divider"/>
          <div className="box">
            <div ref={armyPersonsRef} className="row persons army">
              <div className="col-sm-6 col-md-25 person-col">
                <ArmyUnitPerson
                  unitType={"E1"}
                  unit={selectedMember.army[ARMY_UNITS.E1]}
                  picture={`${selectedMember.race.id}1`}
                  recruit={amount => dispatch(
                    recruitUnit(ARMY_UNITS.E1, amount, selectedMember.id, selectedMember.id === id)
                  )}
                  release={amount => dispatch(
                    releaseUnit(ARMY_UNITS.E1, amount, selectedMember.id, selectedMember.id === id)
                  )}
                />
              </div>
              <div className="col-sm-6 col-md-25 person-col">
                <ArmyUnitPerson
                  unitType={"E2"}
                  unit={selectedMember.army[ARMY_UNITS.E2]}
                  picture={`${selectedMember.race.id}2`}
                  recruit={amount => dispatch(
                    recruitUnit(ARMY_UNITS.E2, amount, selectedMember.id, selectedMember.id === id)
                  )}
                  release={amount => dispatch(
                    releaseUnit(ARMY_UNITS.E2, amount, selectedMember.id, selectedMember.id === id)
                  )}
                />
              </div>
              <div className="col-sm-6 col-md-25 person-col">
                <ArmyUnitPerson
                  unitType={"E3"}
                  unit={selectedMember.army[ARMY_UNITS.E3]}
                  picture={`${selectedMember.race.id}3`}
                  recruit={amount => dispatch(
                    recruitUnit(ARMY_UNITS.E3, amount, selectedMember.id, selectedMember.id === id)
                  )}
                  release={amount => dispatch(
                    releaseUnit(ARMY_UNITS.E3, amount, selectedMember.id, selectedMember.id === id)
                  )}
                />
              </div>
              <div className="col-sm-6 col-md-25 person-col">
                <ArmyUnitPerson
                  unitType={"s_engines"}
                  unit={selectedMember.army[ARMY_UNITS.SIEGE_ENGINE]}
                  picture={"S"}
                  soldierGeneral={selectedMember.generals.soldier.general}
                  recruit={amount => dispatch(
                    recruitUnit(ARMY_UNITS.SIEGE_ENGINE, amount, selectedMember.id)
                  )}
                  release={amount => dispatch(
                    releaseUnit(ARMY_UNITS.SIEGE_ENGINE, amount, selectedMember.id)
                  )}
                />
              </div>
              <div className="col-sm-6 col-md-25 person-col">
                <div className={`person ${systemClass.MatchHeight}`}>
                  <h3 className="name">Red dragon</h3>
                  <img src={armyUnits.armyD} alt=""/>
                  <p className="white">
                    <div className="icons">
                      <p>Magic creature of unknown powers</p>
                    </div>
                    <p className="white">
                      <div className="row">
                        <div
                          className="col-md-4 text-center js-units-dragon col-md-offset-4">{selectedMember.army[ARMY_UNITS.DRAGON]}</div>
                      </div>
                      <div>&nbsp;</div>
                    </p>
                  </p>
                </div>
              </div>
            </div>
          </div>
            <span className="divider"/>

            <h2 className="h2 h2-first">
              <span className="bordered">Banner of {selectedMember.name}</span>
            </h2>
            <span className="divider"/>
            <div className="box">
              {<>
                {selectedMember.readyToAttack
                  ? <div className="text-info">Place army of {selectedMember.name} into alliance formation</div>
                  : (selectedMember.generals.soldier.general
                    ? <span className="negative">Army can not be sent to battle until 8th turn and out of war</span>
                    : <span className="negative">You need soldier general to lead army to battle</span>)
                }
                <ArmyFormationPersons
                  formation={armyFormation}
                  tactics={1}
                />
              </>}
              <span className={"divider"} />
            </div>
          </section>
        </> : <InnerLoader race={race.name} />}
  </section>)
}

export default ArmyEmperorTent;
